module.exports = __webpack_public_path__ + "img/logo_blue.25b67e1c.png";